import type { VoidFunctionComponent } from 'react';

import Locator from '../../../../../../shared/Locator';
import Remediation from '../../../../shared/vulns/Drawer/Remediation';
import type { SelectedVuln } from '../../../../../../shared/organizationPackages/response';

import { getSelectedVulnRemediation } from './utils';

type Props = {
  version: string;
  packageRevisionLocator: string;
  selectedVuln?: SelectedVuln;
  isLoading: boolean;
};

/**
 * Container component for the VulnerabilityDrawerHeader
 */
const PackageVersionVulnerabilityDrawerRemediation: VoidFunctionComponent<Props> = ({
  version,
  packageRevisionLocator,
  selectedVuln,
  isLoading,
}) => {
  const locator = new Locator(packageRevisionLocator);
  const { completeFix, completeFixDistance, partialFix, partialFixDistance } = getSelectedVulnRemediation(selectedVuln);

  return (
    <Remediation
      version={version}
      isLoading={isLoading}
      completeFix={completeFix}
      completeFixDistance={completeFixDistance}
      partialFix={partialFix}
      partialFixDistance={partialFixDistance}
      // Technically, user-defined dependencies won't make it this far because we don't have vuln calculations for them.
      // I am leaving this here in case we change that in the future.
      isUserDefinedDependency={locator.isUserDefined()}
    />
  );
};

export default PackageVersionVulnerabilityDrawerRemediation;
